/*
Next steps:
	- Move all flux stores into this main store
	- Refactor stores to be reducers
*/
import { compose, createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { dashApiInterceptorSetup } from '../support/dash_api';
import { serverReduxSetup } from '../support/server';

import AccessControl from './AccessControlReducer';
import AdLinks from './AdLinksReducer';
import AdPartner from './AdPartnerReducer';
import AgencyRelationshipReducer from './AgencyRelationshipReducer';
import AppReducer from '../../common/reducers/AppReducer';
import AuthServiceReducer from './AuthServiceReducer';
import BillingAccount from './BillingAccountReducer';
import Cnames from './CnamesReducer';
import DataIntegrations from './DataIntegrationsReducer';
import DomainLinks from './DomainLinksReducer';
import EmailOnboarding from './EmailOnboarding';
import Facebook from './FacebookReducer';
import FlipperUpdates from './FlipperReducer';
import Google from './GoogleReducer';
import Invoices from './InvoicesReducer';
import Journey from './JourneyReducer';
import Deepview from './DeepviewReducer';
import Schedule from './ScheduleReducer';
import LinkCreator from './LinkCreatorReducer';
import CsvExport from './CsvExport';
import TuneCustomExport from './CustomExportReducer/TuneCustomExportReducer';
import BranchCustomExport from './CustomExportReducer/BranchCustomExportReducer';
import Org from '../../common/reducers/OrgReducer';
import Payments from './PaymentsReducer';
import PaymentMethods from './PaymentMethodsReducer';
import PbaLiveview from './PbaLiveviewReducer';
import ProductFeeds from './ProductFeedReducer';
import SDKInfo from './SDKInfoReducer';
import SSO from './SsoReducer';
import Subscriptions from './SubscriptionsReducer';
import Team from './TeamReducer';
import ThirdPartyGlobalSettings from './ThirdPartyGlobalSettingsReducer';
import ThirdPartyProviderConfig from './ThirdPartyProviderConfigReducer';
import Webhooks from './WebhooksReducer';
import AppleSearchAds from './AppleSearchAdsReducer';
import Snap from './SnapReducer';
import Twitter from './TwitterReducer';
import Tiktok from './TikTokReducer';
import TiktokSAN from './TikTokSANReducer';
import Fraud from './FraudReducer';
import FraudFighter from './FraudFighterReducer';
import MicroFrontends from './MicroFrontendsReducer';
import Activity from './ActivityReducer';
import LogoutModal from './LogoutModalReducer';
import PersonaServiceReducer from './PersonaServiceReducer'; // rename to reducer
import WhitelistedDeviceOrmReducer from './WhitelistedDeviceOrmReducer';
import DiscoAds from './DiscoAdsReducer';
import Audience from './AudienceReducer';
import SKAdnetwork from './SKAdnetworkReducer';
import UserEntityTerms from '../../common/reducers/UserEntityTermsReducer';
import AppStoreVerification from './AppStoreVerificationReducer';
import QuickLinkTemplateReducer from './QuickLinkTemplateReducer';
import LinkByQueryReducer from './LinkManager/LinkByQueryReducer';
import EventsReducer from './Events/EventsReducer';
import PrebuiltMacrosReducer from './PrebuiltMacros/PrebuiltMacrosReducer';
import AlertNotificationsReducer from './AlertNotificationsReducer';
import CustomCalculationReducer from './CustomCalculationReducer';
import CreationDialogReducer from './LinkManager/CreationDialogReducer';
import QuickLinkCreatorReducer from './QuickLinkCreatorReducer/QuickLinkCreatorReducer';
import AdLinkCreatorReducer from './AdLinkCreatorReducer/AdLinkCreatorReducer';
import LinkHubCreatorReducer from './LinkHubCreatorReducer/LinkHubCreatorReducer';
import UsageReducer from './Usage/UsageReducer';
import StatusReducer from './StatusReducer';
import AdLinkTemplateReducer from './AdLinkTemplateReducer/AdLinkTemplateReducer';
import AppCategoryReducer from './AppCategoryReducer';
import SKANConversionValueMappingReducer from './SKANPostbacksConversionMapping/SKANPostbacksConversionMappingReducer';
import UserOnboardingDataReducer from '../../common/reducers/UserOnboardingDataReducer';

export const reducers = {
  accessControl: AccessControl,
  activity: Activity,
  ad_links: AdLinks,
  ad_partner: AdPartner,
  adLinkCreator: AdLinkCreatorReducer,
  ad_link_templates: AdLinkTemplateReducer,
  agencyRelationship: AgencyRelationshipReducer,
  alertNotifications: AlertNotificationsReducer,
  app: AppReducer,
  app_status: StatusReducer,
  app_category: AppCategoryReducer,
  appStoreVerification: AppStoreVerification,
  apple_search_ads: AppleSearchAds,
  audience: Audience,
  auth_service: AuthServiceReducer,
  billing_account: BillingAccount,
  branchCustomExport: BranchCustomExport,
  cnames: Cnames,
  creationDialog: CreationDialogReducer,
  csvExport: CsvExport,
  customCalculations: CustomCalculationReducer,
  dataIntegrations: DataIntegrations,
  deepview: Deepview,
  disco_ads: DiscoAds,
  domainLinks: DomainLinks,
  druid: require('../../common/reducers/DruidReducer').default,
  emailOnboarding: EmailOnboarding,
  events: EventsReducer,
  facebook: Facebook,
  flipper_updates: FlipperUpdates,
  fraud: Fraud,
  fraud_fighter: FraudFighter,
  google: Google,
  health_checks: require('./HealthCheckReducer').default,
  invoices: Invoices,
  journey: Journey,
  link_by_query: LinkByQueryReducer,
  linkCreator: LinkCreator,
  linkHubCreator: LinkHubCreatorReducer,
  logout_modal: LogoutModal,
  micro_frontends: MicroFrontends,
  ob_link: require('../../common/reducers/OnboardingLinkReducer').default,
  org: Org,
  payments: Payments,
  payment_methods: PaymentMethods,
  persona_service: PersonaServiceReducer,
  pba_liveview: PbaLiveview,
  prebuiltMacros: PrebuiltMacrosReducer,
  product_feeds: ProductFeeds,
  quickLinkCreator: QuickLinkCreatorReducer,
  quick_link_templates: QuickLinkTemplateReducer,
  quick_links: require('./QuickLinksReducer').default,
  schedule: Schedule,
  sdk_info: SDKInfo,
  shareable: require('../../common/reducers/ShareableReducer').default,
  skadnetwork: SKAdnetwork,
  skan_conversion_value_mapping: SKANConversionValueMappingReducer,
  snap: Snap,
  sso: SSO,
  subscriptions: Subscriptions,
  team: Team,
  third_party_global_settings: ThirdPartyGlobalSettings,
  third_party_provider_config: ThirdPartyProviderConfig,
  tiktok: Tiktok,
  tiktok_san: TiktokSAN,
  tuneCustomExport: TuneCustomExport,
  twitter: Twitter,
  usage: UsageReducer,
  user: require('../../common/reducers/UserReducer').default,
  userEntityTerms: UserEntityTerms,
  userOnboardingData: UserOnboardingDataReducer,
  webhook: Webhooks,
  whitelist_devices: WhitelistedDeviceOrmReducer,
};

const app = combineReducers(reducers);

const composeEnhancers =
  process.env.NODE_ENV != 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: 'Dashboard',
      })
    : compose;

const getMiddlewares = () => {
  const middlewares = [thunk];
  return middlewares;
};

const enhancer = composeEnhancers(applyMiddleware(...getMiddlewares()));

const store = createStore(app, enhancer);

dashApiInterceptorSetup(store);
serverReduxSetup(store);

export default store;
